import widget from './widget';

export default {
  ...widget,
};
